import React from "react"
import ZdqConnectorSetup from "../../components/ZdqConnectorSetup"
import { DATABRICKS } from "../../Constants"

function ZdqDatabricksConnector() {
    return <ZdqConnectorSetup vendor={DATABRICKS}></ZdqConnectorSetup>
}

export default ZdqDatabricksConnector 